/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Payments_CountInputs */

const en_admin_payments_count = /** @type {(inputs: Admin_Payments_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} payments`)
};

const zh_admin_payments_count = /** @type {(inputs: Admin_Payments_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`共 ${i?.count} 条`)
};

/**
* | output |
* | --- |
* | "{count} payments" |
*
* @param {Admin_Payments_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_count = /** @type {((inputs: Admin_Payments_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_count(inputs)
	return zh_admin_payments_count(inputs)
});
export { admin_payments_count as "admin.payments.count" }